import { matchPath } from 'react-router-dom';
import _ from 'lodash';

const hasSomeOptions = groups => _.some(_.flatMap(groups));

const isStepEnabled = (step, config) => {
  switch (step.key) {
    case 'CONFIG':
    case 'TRIM':
    case 'COLOR':
    case 'SUMMARY':
      return true;
    case 'INTERIOR':
      return hasSomeOptions(config.interior);
    case 'EXTERIOR':
      return hasSomeOptions(config.exterior);
    case 'PACKAGES':
      return hasSomeOptions(config.packages);
    case 'ACCESSORIES':
      return hasSomeOptions(config.accessories);
    default:
      return false;
  }
};

const computeSteps = (steps, visited, config, location) => {
  const items = steps
    .filter(step => isStepEnabled(step, config))
    .map((step, index) => {
      const { key, path } = step;
      return {
        key,
        path,
        active: !!matchPath(location.pathname, { path }),
        visited: _.includes(visited, key),
        index: index + 1
      };
    });

  const activeIndex = _.findIndex(items, 'active');

  if (activeIndex === -1) {
    return {
      items
    };
  }

  return {
    items,
    prev: items[activeIndex - 1],
    active: items[activeIndex],
    next: items[activeIndex + 1]
  };
};

export default computeSteps;
